export default [

     {
          path: '/milestone-setting',
          name: 'MilestoneSetting',
          component: () => import("@/views/Page/MilestoneSetting/MilestoneSetting.vue"),
          meta: {
               title: 'Milestone Setting',
          },
     }
];